// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { FormattedException } from "./FormattedException";
import {
  FormattedExceptionFromJSON,
  FormattedExceptionFromJSONTyped,
  FormattedExceptionToJSON,
  FormattedExceptionToJSONTyped,
} from "./FormattedException";
import type { LogLevelEnum } from "./LogLevelEnum";
import {
  LogLevelEnumFromJSON,
  LogLevelEnumFromJSONTyped,
  LogLevelEnumToJSON,
  LogLevelEnumToJSONTyped,
} from "./LogLevelEnum";
import type { JobId } from "./JobId";
import { JobIdFromJSON, JobIdFromJSONTyped, JobIdToJSON, JobIdToJSONTyped } from "./JobId";

/**
 *
 * @export
 * @interface Log
 */
export interface Log {
  /**
   *
   */
  jobId: JobId;
  /**
   *
   */
  loggerName: string;
  /**
   *
   */
  logLevel: LogLevelEnum;
  /**
   *
   */
  message: string;
  /**
   *
   */
  exception?: FormattedException | null;
  /**
   *
   */
  timestamp: Date;
}

/**
 * Check if a given object implements the Log interface.
 */
export function instanceOfLog(value: object): value is Log {
  if (
    (!("jobId" in (value as Record<string, any>)) &&
      !("job_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["jobId"] === undefined &&
      (value as Record<string, any>)["job_id"] === undefined)
  )
    return false;
  if (
    (!("loggerName" in (value as Record<string, any>)) &&
      !("logger_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["loggerName"] === undefined &&
      (value as Record<string, any>)["logger_name"] === undefined)
  )
    return false;
  if (
    (!("logLevel" in (value as Record<string, any>)) &&
      !("log_level" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["logLevel"] === undefined &&
      (value as Record<string, any>)["log_level"] === undefined)
  )
    return false;
  if (!("message" in value) || value["message"] === undefined) return false;
  if (!("timestamp" in value) || value["timestamp"] === undefined) return false;
  return true;
}

export function LogFromJSON(json: any): Log {
  return LogFromJSONTyped(json, false);
}

export function LogFromJSONTyped(json: any, ignoreDiscriminator: boolean): Log {
  if (json == null) {
    return json;
  }
  return {
    jobId: JobIdFromJSON(json["job_id"]),
    loggerName: json["logger_name"],
    logLevel: LogLevelEnumFromJSON(json["log_level"]),
    message: json["message"],
    exception:
      json["exception"] === undefined
        ? undefined
        : json["exception"] === null
        ? null
        : FormattedExceptionFromJSON(json["exception"]),
    timestamp: json["timestamp"] == null ? json["timestamp"] : parseDateTime(json["timestamp"]),
  };
}

export function LogToJSON(json: any): Log {
  return LogToJSONTyped(json, false);
}

export function LogToJSONTyped(value?: Log | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    job_id: JobIdToJSON(value["jobId"]),
    logger_name: value["loggerName"],
    log_level: LogLevelEnumToJSON(value["logLevel"]),
    message: value["message"],
    exception: FormattedExceptionToJSON(value["exception"]),
    timestamp:
      value["timestamp"] == null ? value["timestamp"] : serializeDateTime(value["timestamp"]),
  };
}
